import * as React from 'react';

const LoginSvg = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={30} height={27} fill='none' {...props}>
    <path
      stroke='#9E9E9E'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2.375}
      d='M10.25 7.938v-2.97A2.969 2.969 0 0 1 13.219 2h11.875a2.969 2.969 0 0 1 2.968 2.969V22.78a2.97 2.97 0 0 1-2.968 2.969H13.812c-1.639 0-3.562-1.33-3.562-2.969v-2.968m7.125 0 5.938-5.938-5.938-5.938M1.937 13.875h20.188'
    />
  </svg>
);
export default LoginSvg;
